module.exports = "<div *ngFor=\"let key of textInputControl.inputNames\">\n  <mdl-textfield \n    type=\"text\"\n    [label]=\"textboxLabels[key]\"\n    [(ngModel)]=\"textInputControl.textboxInput[key]\"\n    (input)=\"onTextboxChange(key, $event.target.value)\"\n    [rows]=rows\n    floating-label\n    [disabled]=disabled\n    [style.width]=\"'100%'\"></mdl-textfield>\n  <p *ngIf=\"!textInputControl.textboxValid[key]\">\n    The {{key}} input is invalid\n  </p>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/misc-components/shared-text-input-template.html
 ** module id = 144
 ** module chunks = 0
 **/